/**
 * <TutorWeekGrid> — la semaine du tuteur, une rangée d'heures par jour (organism).
 *
 * La grille de « Ma dispo » et de « Libérer des créneaux » (legacy `MaDispoWeekGrid`) : la même
 * grille, les mêmes gestes, pour que le tuteur ne réapprenne rien d'un écran à l'autre. C'est
 * `<TimeSlotGrid>`, la grille de la famille — ses deux dispositions (une colonne par jour au large,
 * des journées empilées à l'étroit, sur la largeur du conteneur) — dont chaque cellule est une
 * `<TutorHourChip>` à quatre états, et dont chaque jour dit ce qu'il compte (« 2/3 dispos · 1 live »,
 * `tutorDayCaption`).
 *
 * Contrôlée : les jours et l'état de chaque heure arrivent en props, le toucher remonte avec l'heure.
 * C'est l'écran qui décide ce qu'un toucher veut dire (prendre, retirer, ouvrir la boîte d'un live,
 * libérer).
 */
import React from "react"

import { TutorHourChip } from "../../molecules/TutorHourChip"
import { TimeSlotGrid } from "../TimeSlotGrid"
import { tutorDayCaption } from "../../../ports/primary/ui/formatters/tutorWeekFormatter"
import { type UITutorHour, type UITutorWeekDay } from "../../../ports/primary/ui/types/tutorDispoOffres"

export type TutorWeekGridProps = {
    days: UITutorWeekDay[]
    onPressHour?: (hour: UITutorHour) => void
    testID?: string
}

export function TutorWeekGrid(props: TutorWeekGridProps) {
    const { days, onPressHour, testID } = props

    return (
        <TimeSlotGrid
            testID={testID}
            days={days}
            renderSlot={(hour, fullWidth) => <TutorHourChip hour={hour} onPress={onPressHour} fullWidth={fullWidth} />}
            dayCaption={(day) => tutorDayCaption(day.slots)}
        />
    )
}
